const $ = require('jquery');

// add target blank to all outbound links
$("a").each(function() {
  const a = new RegExp("/" + window.location.host + "/");
  if (!a.test(this.href)) {
    $(this).attr("target", "_blank");
  }
});

// also add taget blank for all pdfs
$('a[href$=".pdf"]').prop('target', '_blank');

// get rid of target blank for phone numbers
$('a[href^="tel:"]').prop('target', '_self');
